let load = require('./helpers/browser/esm-js-loader-shards-super.js')(4);
module.exports = (load("aNt1P")).then(() => parcelRequire('k1v6H'));